import React from "react";
import { TextField, MenuItem } from "@mui/material";
import Select from "react-select";
import { selectCustomStyles } from "../../assets/styles/MuiStyle";

const CustomSelect1 = ({
  label,
  options,
  placeholder,
  state,
  setState,
  id,
  margin,
  isStarted = true,
}) => {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setState(selectedValue); 
  };
  return (
    <TextField
      select
      label={
        label ? (
          <span>
            {label} {isStarted && <span style={{ color: "red" }}>*</span>}
          </span>
        ) : null
      }
      variant="outlined"
      fullWidth
      id={id}
      name={id}
      value={state || ""} // Controlled by the state
      onChange={handleChange} // Update the state on change
      InputLabelProps={
        label
          ? {
              shrink: true,
              sx: {
                position: "absolute",
                top: "0px",
                left: "-4px",
                background: "#fff",
                padding: "0 4px",
              },
            }
          : undefined
      }
      SelectProps={{
        displayEmpty: true,
        MenuProps: {
          PaperProps: {
            sx: {
              maxHeight: 224,
              // width: 250,
            },
          },
        },
        sx: {
          color: state === "" ? "#9E9E9E" : "inherit",
        },
      }}
      sx={{
        height: "40px",
        marginTop: margin || 0,
        "& .MuiInputBase-root": {
          height: "40px",
          lineHeight: "40px",
        },
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          height: "40px",
          lineHeight: "40px",
          fontFamily: "Urbane-Light",
        },
        "& .MuiInputBase-input": {
          padding: "0 39px",
          fontSize: "12px",
          margin: "-1px",
          fontFamily: "Urbane-Light",
        },
        
      }}
      renderValue={(selected) => {
        if (selected === "") {
          return <span style={{ color: "#9E9E9E" }}>{placeholder}</span>;
        }
        return options.find((option) => option.value === selected)?.label;
      }}
    >
      <MenuItem
        value=""
        disabled
        sx={{
          display: "none",
        }}
      >
        {placeholder}
      </MenuItem>
      {options.map((option, index) => (
        <MenuItem key={index} value={option.value} sx={{ height: 40 }}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
export default CustomSelect1;

export const CustomStatusSelectForInvoice = ({
  options,
  placeholder,
  state,
  setState,
  id,
  ...props
}) => {
  const handleChange = (selectedOption) => {
    setState(selectedOption?.value); // Update the state with the selected option
  };

  return (
    <>
      <Select
        id={id}
        name={id}
        options={options}
        value={state} // This needs to be the full option, not just the value
        onChange={handleChange}
        placeholder={placeholder}
        styles={selectCustomStyles}
        isSearchable
        {...props}
      />
    </>
  );
};
